<template>
  <div>
    <h3>
      {{ titleobj.projectLeaderName }}负责的项目【{{ titleobj.name }}】已开始{{
        titleobj.useTime
      }}天，当前进度 “{{ titleobj.stateName }}”
    </h3>
    <div class="tab-list">
      <Row
        :gutter="8"
        style="margin: 0px 0 0 0; width: 100%"
        v-if="menus && menus.length > 0"
      >
        <Menu
          mode="horizontal"
          :active-name="menu_name"
          @on-select="selectMenu"
          style="width: 100%"
        >
          <div v-for="(v, k) in menus" style="display: inline-block" :key="k">
            <MenuItem :name="v.name" v-auth="v.auth" @click="v.onClick">
              <Badge
                :overflow-count="10000000"
                v-if="v.badge && v.badge.count"
                :count="v.badge.count"
                :offset="[18, -3]"
              >
                {{ v.label }}
              </Badge>
              <span v-if="!(v.badge && v.badge.count)">
                {{ v.label }}
              </span>
            </MenuItem>
          </div>
        </Menu>
      </Row>
    </div>
    <Row
      :gutter="8"
      style="margin: 10px 0 0 0; width: 100%"
      v-if="filters && filters.length > 0"
    >
      <Collapse style="width: 100%" v-model="value1">
        <Panel style="width: 100%" name="1">
          展开搜索条件
          <Form
            ref="formQuery"
            :label-width="80"
            :label-position="left"
            :label-colon="true"
            :model="query"
            style="
              display: flex;
              flex-direction: row-reverse;
              justify-content: flex-end;
              flex-wrap: wrap;
              width: 80%;
              margin-top: 10px;
            "
            slot="content"
          >
            <Col
              span="3"
              :xxl="6"
              :xl="4"
              :lg="6"
              :md="8"
              :sm="12"
              :xs="24"
              style="
                display: flex;
                flex-direction: row-reverse;
                position: absolute;
                right: 20px;
              "
            >
              <Button icon="ios-search" type="info" @click="search1" style="width: 90px"
                >搜索
              </Button>
              <Button
                icon="ios-close-circle"
                type="error"
                @click="clearFilter"
                style="width: 90px; margin-right: 15px"
              >
                重置
              </Button>
            </Col>
            <template v-for="(v, k) in filters">
              <Col
                :key="k"
                span="3"
                :xxl="6"
                :xl="7"
                :lg="9"
                :md="12"
                :sm="12"
                :xs="24"
                v-if="v.type === 'inputs'"
                style="margin: 0px 0 10px 0; float: right; display: flex"
              >
                <FormItem :label="v.label" style="margin-bottom: 0">
                  <div style="margin-bottom: 0; display: flex">
                    <Input
                      :key="k"
                      :placeholder="'最小' + v.label"
                      clearable
                      v-model="query[v.name1]"
                    ></Input>
                    <div>~</div>
                    <Input
                      :key="k"
                      :placeholder="'最大' + v.label"
                      clearable
                      v-model="query[v.name2]"
                    ></Input>
                  </div>
                </FormItem>
              </Col>
              <Col
                :key="k"
                span="3"
                :xxl="6"
                :xl="7"
                :lg="9"
                :md="12"
                :sm="12"
                :xs="24"
                v-if="v.type === 'string' || v.type === 'text' || v.type === 'input'"
                style="margin: 0px 0 10px 0; float: right; display: flex"
              >
                <FormItem :label="v.label" style="margin-bottom: 0">
                  <Input
                    :key="k"
                    :placeholder="v.label"
                    clearable
                    v-model="query[v.name]"
                    @keyup.enter.native="v.KeyEnter"
                  ></Input>
                </FormItem>
              </Col>
              <Col
                :key="k"
                span="3"
                :xxl="6"
                :xl="7"
                :lg="9"
                :md="12"
                :sm="12"
                :xs="24"
                v-else-if="v.type === 'select'"
                style="margin: 0px 0 10px 0; float: right"
              >
                <FormItem :label="v.label" style="margin-bottom: 0">
                  <i-select
                    :key="k"
                    v-model="query[v.name]"
                    clearable
                    style="width: 193px"
                    @keyup.enter.native="v.KeyEnter"
                    :multiple="v.multiple ? true : false"
                    :disabled="v.disabled ? true : false"
                    :placeholder="v.label"
                    :filterable="true"
                    @on-change="v.onChange"
                  >
                    <Option :value="s.value" v-for="(s, sk) in v.dropList || []" :key="sk"
                      >{{ s.name }}
                    </Option>
                  </i-select>
                </FormItem>
              </Col>
              <Col
                :key="k"
                span="3"
                :xxl="6"
                :xl="7"
                :lg="9"
                :md="12"
                :sm="12"
                :xs="24"
                v-else-if="v.type === 'selectsearch'"
                style="margin: 0px 0 10px 0; float: right"
              >
                <FormItem :label="v.label" style="margin-bottom: 0">
                  <i-select
                    :key="k"
                    v-model="query[v.name]"
                    clearable
                    remote
                    filterable
                    @keyup.enter.native="v.KeyEnter"
                    :remote-method="v.remoteMethod"
                    style="width: 193px"
                    :multiple="v.multiple ? true : false"
                    :disabled="v.disabled ? true : false"
                    :placeholder="v.label"
                    @on-change="v.onChange"
                  >
                    <Option :value="s.value" v-for="(s, sk) in v.dropList || []" :key="sk"
                      >{{ s.name }}
                    </Option>
                  </i-select>
                </FormItem>
              </Col>
              <Col
                :key="k"
                span="3"
                :xxl="6"
                :xl="7"
                :lg="9"
                :md="12"
                :sm="12"
                :xs="24"
                v-else-if="v.type === 'datetimerange'"
                style="margin: 0px 0 10px 0; float: right"
              >
                <FormItem :label="v.label" style="margin-bottom: 0">
                  <DatePicker
                    clearable
                    :key="k"
                    type="daterange"
                    v-model="query1[v.name + v.lable]"
                    style="width: 193px"
                    @keyup.enter.native="v.KeyEnter"
                    format="yyyy-MM-dd"
                    placeholder="选择时间"
                    :options="optionsData"
                    @on-change="
                      (val) => {
                        timeDateChange(val, v.name);
                      }
                    "
                  ></DatePicker>
                </FormItem>
              </Col>
              <Col
                :key="k"
                v-else-if="v.type === 'distpicker'"
                style="margin: 0px 0 10px 0; float: right"
              >
                <FormAddress
                  @on-change="
                    (val) => {
                      onAddressChange(val, v.name);
                    }
                  "
                  style="width: 100%"
                ></FormAddress>
              </Col>
              <Col
                :key="k"
                span="3"
                :xxl="6"
                :xl="7"
                :lg="9"
                :md="12"
                :sm="12"
                :xs="24"
                v-else-if="v.type === 'addressInfo'"
                style="width: auto; margin: 0px 0 10px 0; float: right"
              >
                <FormItem :label="v.label" style="margin-bottom: 0">
                  <v-distpicker
                    :disabeld="disabeld"
                    type="addressInfo"
                    :province="province"
                    :city="city"
                    :area="area"
                    @selected="v.onSelect"
                  ></v-distpicker>
                </FormItem>
              </Col>
            </template>
          </Form>
        </Panel>
      </Collapse>
    </Row>
    <div class="addactivity">
      <Button type="info" ghost @click="addactivity()">新建activity</Button>
    </div>
    <div class="addactivity">
      <div v-for="(v, k) in Data" :key="k">
        <Card
          dis-hover
          :bordered="true"
          style="margin: 10px 0"
          v-show="Data.length == 0 ? false : true"
        >
          <Row align="top" justify="space-between">
            <Col span="3" class="left">{{ v.fillingTime }}</Col>
            <Col span="12" class="center">
              <p style="margin-bottom: 10px">
                <span style="color: #42b983">{{ v.createBy }}</span
                ><span>写道:</span>
              </p>
              <p v-html="v.content"></p>
            </Col>
            <Col span="3" class="right">
              <p style="margin-bottom: 10px">当前进度</p>
              <p style="color: #fa795e">{{ v.state }}</p>
            </Col>
            <Col span="2" class="right">
              <p v-show="v.remarkUrl ? true : false" style="margin-bottom: 10px">附件</p>
              <svg
                @click="handleRender(v.remarkUrl)"
                v-show="v.remarkUrl ? true : false"
                t="1686795127586"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="7800"
                width="20"
                height="20"
              >
                <path
                  d="M848.8576 199.1936H415.7568c0-26.5728-21.5424-48.128-48.128-48.128H175.1424c-26.5728 0-48.128 21.5424-48.128 48.128V343.5648c0 26.5984 21.5424 48.1408 48.128 48.1408h673.728c26.5728 0 48.128-21.5424 48.128-48.1408v-96.2432c-0.0128-26.5856-21.5552-48.128-48.1408-48.128z"
                  fill="#CCA352"
                  p-id="7801"
                ></path>
                <path
                  d="M800.7424 247.3088H223.2576c-26.5728 0-48.128 21.5424-48.128 48.128v48.128c0 26.5984 21.5424 48.1408 48.128 48.1408h577.472c26.5728 0 48.128-21.5424 48.128-48.1408v-48.128c0-26.5728-21.5424-48.128-48.1152-48.128z"
                  fill="#FFFFFF"
                  p-id="7802"
                ></path>
                <path
                  d="M848.8576 295.4368H175.1424c-26.5728 0-48.128 21.5424-48.128 48.128v481.2544c0 26.5472 21.5424 48.128 48.128 48.128h673.728c26.5728 0 48.128-21.568 48.128-48.128V343.552c-0.0128-26.5728-21.5552-48.1152-48.1408-48.1152z"
                  fill="#FFCC66"
                  p-id="7803"
                ></path>
              </svg>
            </Col>
            <Col span="4">
              <div style="cursor: pointer; color: #2a75ed">
                <span style="margin-right: 10px" @click="toggleBlock(v)">评论</span>
                <span style="margin-right: 10px" @click="onEdit(v)">编辑</span>
                <span @click="onDel(v)">删除</span>
              </div>
            </Col>
          </Row>
          <Row justify="space-between" v-show="v.block">
            <Divider style="margin: 15px 0" />
            <!-- <Col span="2">
              <Avatar src="https://i.loli.net/2017/08/21/599a521472424.jpg" />
            </Col> -->
            <Col span="18">
              <Input v-model="content" placeholder="写下你的想法..." />
            </Col>
            <Col span="4">
              <Button type="info" ghost @click="oncomment(v)">评论</Button>
            </Col>
          </Row>
          <div v-show="v.childrenList ? true : false">
            <el-collapse @change="handleChange" style="margin-top: 15px">
              <el-collapse-item>
                <template slot="title">
                  查看评论 <i class="header-icon el-icon-chat-dot-square"></i>
                </template>
                <div v-for="(item, index) in v.childrenList" :key="index">
                  <Row justify="space-between">
                    <Col>
                      <span style="color: #2a75ed">{{ item.fname }}</span>
                      <span>:{{ item.content }}</span>
                    </Col>
                    <Col>
                      <span style="color: #9499a0; margin-right: 10px">{{
                        item.fillingTime
                      }}</span>
                      <el-button
                        style="padding: 0"
                        type="text"
                        @click="toggleBlock2(item)"
                        >回复</el-button
                      >
                    </Col>
                  </Row>
                  <div v-show="item.childrenList ? true : false">
                    <div v-for="(item, index) in item.childrenList" :key="index">
                      <Row justify="space-between" style="margin-left: 25px">
                        <Col>
                          <span style="color: #2a75ed">{{ item.fname }}</span>
                          <span>:{{ item.content }}</span>
                        </Col>
                        <Col>
                          <span style="color: #9499a0; margin-right: 10px">{{
                            item.fillingTime
                          }}</span>
                        </Col>
                      </Row>
                    </div>
                  </div>
                  <Row justify="space-between" v-show="item.block" style="margin: 10px 0">
                    <Col span="18">
                      <Input v-model="content" placeholder="写下你的想法..." />
                    </Col>
                    <Col span="4">
                      <Button type="info" ghost @click="oncomment2(item)">评论</Button>
                    </Col>
                  </Row>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </Card>
      </div>
      <Card
        v-show="Data.length == 0 ? true : false"
        :bordered="true"
        style="margin: 10px 0"
      >
        <p>暂无进度</p>
      </Card>
    </div>
  </div>
</template>

<script>
import config from "../../../../config";
import Addactivity from "./addactivity.vue";
let customerId = window.localStorage.getItem("customerId");
import dayjs from "dayjs";
import baseList from "@/views/components/base/baseList.vue";

export default {
  extends: baseList,
  data() {
    return {
      styles: {
        height: "calc(100% - 55px)",
        overflow: "auto",
        paddingBottom: "53px",
        position: "static",
        fontWeight: "500",
      },
      menus: [
        {
          label: "项目全景",
          name: "panorama",
        },
        {
          label: " 跟进记录",
          name: "schedule_Info",
        },
        {
          label: "任务",
          name: "task_Info",
        },
        {
          label: Number(customerId) == 0 ? "客户" : "供应商",
          name: "supplier_List",
        },
        {
          label: "合同",
          name: "contract_Info",
        },
        {
          label: "发票/支付",
          name: "invoice_Info",
        },
      ],
      value1: "0",
      filters: [
        {
          label: "进度节点",
          name: "schedule",
          value: "",
          KeyEnter: this.search1,
          type: "select",
          dropList: [],
        },
      ],
      Data: [],
      menu_name: "",
      customerId: "",
      schedule: Number(""),
      projectId: window.localStorage.getItem("projectId"),
      titleobj: {},
      fillingTime: "",
      scheduleId: "",
      content: "",
      page: 1,
      pageSize: 20,
    };
  },
  created() {
    this.initData(this.projectId);
    this.loadLevelDatas();
    let query = this.$route.query;
    if (query.scheduleId) {
      this.load1(query.scheduleId);
    } else {
      this.load();
    }
    let route = this.$route;
    if (route) {
      this.menu_name = route.name;
    }
  },
  methods: {
    clearFilter() {
      this.query = {};
      sessionStorage.removeItem(this.filterKey);
      this.load();
    },
    search1() {
      this.load1(this.query.schedule);
    },
    loadLevelDatas() {
      let q = { projectId: this.projectId };
      $utils.api.load("/admin/system/managementContent/list", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.scheduleId;
            xx.name = element.scheduleName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "schedule") {
              this.filters[index]["dropList"] = (element["dropList"] || []).concat(
                dropList
              );
            }
          }
        }
      });
    },
    toggleBlock(v) {
      v.block = !v.block; // 切换 v.block 的值
    },
    toggleBlock2(v) {
      v.block = !v.block; // 切换 v.block 的值
    },
    oncomment(v) {
      if (this.content == "") {
        $utils.toast.warn("请输入内容!");
        return;
      }
      let q = {
        content: this.content,
        fillingTime: dayjs().format("YYYY年MM月DD日 HH:mm"),
        pid: v.fid,
        pname: v.fname,
        projectId: this.projectId,
        floorId: v.id,
      };
      $utils.api.load("/admin/system/activity", q, "POST").then((res) => {
        this.loading = false;
        if (res.code == 200) {
          $utils.toast.success("评论成功");
          this.content = "";
          this.load();
        }
      });
    },
    oncomment2(v) {
      if (this.content == "") {
        $utils.toast.warn("请输入内容!");
        return;
      }
      let q = {
        content: this.content,
        fillingTime: dayjs().format("YYYY年MM月DD日 HH:mm"),
        pid: v.fid,
        pname: v.fname,
        projectId: this.projectId,
        floorId: v.id,
      };
      $utils.api.load("/admin/system/activity", q, "POST").then((res) => {
        this.loading = false;
        if (res.code == 200) {
          $utils.toast.success("评论成功");
          this.content = "";
          this.load();
        }
      });
    },
    handleRender(text) {
      const texturl = text.split(",");
      for (let i = 0; i < texturl.length; i++) {
        texturl[i] = config.IMAGE_HOST + texturl[i];
      }
      let files = texturl.map((texturl) => {
        const parts = texturl.split("#");
        return {
          url: parts[0],
          name: parts[1],
        };
      });
      this.$Modal.success({
        closable: true,
        title: `查看附件`,
        width: "400px",
        okText: "取消",
        showOk: false,
        render: (h) => {
          return (
            <div>
              <List border size="small">
                {files.map((item) => {
                  return (
                    <ListItem>
                      <a href={item.url} target="_blank">
                        {item.name}
                      </a>
                    </ListItem>
                  );
                })}
              </List>
            </div>
          );
        },
      });
    },
    async load1(id) {
      let d = { projectId: this.projectId,schedule :id };
      let res = await $utils.api.load("/admin/system/activity/list", d, "get");
      if (res.code == 200) {
        let arr = res.rows;
        if (arr.length > 0) {
          this.Data = arr.map(
            ({
              childrenList,
              createBy,
              content,
              fillingTime,
              scheduleName,
              remarkUrl,
              schedule,
              id,
              fid,
              fname,
            }) => {
              if (childrenList) {
                childrenList.forEach((child) => {
                  child.block = false;
                });
              }
              return {
                createBy,
                content,
                fillingTime,
                state: scheduleName,
                remarkUrl,
                schedule,
                id,
                fid,
                fname,
                block: false,
                childrenList,
              };
            }
          );
        } else {
          this.Data = [];
        }
      }
    },
    async load() {
      let d = { projectId: this.projectId };
      let res = await $utils.api.load("/admin/system/activity/list", d, "get");
      if (res.code == 200) {
        let arr = res.rows;
        if (arr.length > 0) {
          this.Data = arr.map(
            ({
              childrenList,
              createBy,
              content,
              fillingTime,
              scheduleName,
              remarkUrl,
              schedule,
              id,
              fid,
              fname,
            }) => {
              if (childrenList) {
                childrenList.forEach((child) => {
                  child.block = false;
                });
              }
              return {
                createBy,
                content,
                fillingTime,
                state: scheduleName,
                remarkUrl,
                schedule,
                id,
                fid,
                fname,
                block: false,
                childrenList,
              };
            }
          );
        } else {
          this.Data = [];
        }
      }
    },
    async initData(id) {
      if (id) {
        let res = await $utils.api.load(`/admin/system/management/${id}`);
        try {
          if (res.code == 200) {
            this.titleobj = res.data;
            if (res.data.scheduleId) {
              this.scheduleId = res.data.scheduleId;
            }
          }
        } catch (e) {
          console.log(e);
        }
      }
    },
    addactivity() {
      this.$Modal.success({
        title: "新建activity",
        closable: true,
        width: "800px",
        okText: "取消",
        showOk: false,
        render: () => {
          return (
            <div>
              <Addactivity id={this.scheduleId} />
            </div>
          );
        },
      });
    },
    selectMenu(name) {
      if (this.menu_name !== name) {
        setTimeout(() => {
          this.$destroy();
        }, 100);
        $utils.url.push({ name: name, params: { refresh: true } });
      }
    },
    onEdit(row) {
      this.$Modal.success({
        title: "编辑activity",
        closable: true,
        width: "800px",
        okText: "取消",
        showOk: false,
        render: () => {
          return (
            <div>
              <Addactivity id={this.scheduleId} data={row} Edit="edit" />
            </div>
          );
        },
      });
    },
    onDel(row) {
      $utils.api.load(`/admin/system/activity/${row.id}`, {}, "DELETE").then((res) => {
        this.load();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.addactivity {
  margin-top: 10px;
}
.icon {
  cursor: pointer;
}
.center {
  p {
    text-align: left;
  }
}
.header-icon {
  font-size: 18px;
  margin-left: 3px;
}
/deep/ .el-collapse-item__header {
  height: 35px !important;
}
</style>
